import { Component, OnInit } from '@angular/core';
import { CustomerService } from '../../customer.service';
import {  Router } from '@angular/router';

@Component({
  selector: 'app-customer-card',
  templateUrl: './customer-card.component.html',
  styleUrls: ['./customer-card.component.scss']
})
export class CustomerCardComponent implements OnInit {
  cards: any = [];
  public href = '';
  url = 'asdf';
  id: number;
  p = 1;
  ids: string;
  spin: boolean;
  constructor(
    private customerService: CustomerService,
    private router: Router
  ) { }

  ngOnInit() {
    this.href = this.router.url;
    this.ids = this.href.split('/')[3];
    // tslint:disable-next-line: radix
    this.id = parseInt(this.ids);
    this.getCustomerCard();
  }
  getCustomerCard() {
    this.customerService.GETAllCardsByCustomerId(this.id).subscribe(Response => {
      this.cards = Response['CustomerCards'];
      // console.log('caarddddddddddddddd', this.cards);
      if (!this.cards[0].Id) {
        this.spin = false;
      } else {
        this.spin = true;
      }
      // console.log(Response);
      // console.log(Response['CustomerCards']);

    });
  }

}
